<app-header [noButtons]="true" [enableLogout]="true"></app-header>
<div class="container">
  <mat-card appearance="outlined" class="center-card">
    <mat-card-header>
      <mat-card-title>{{
        'pages.hub-selector.header' | transloco
      }}</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      @if (licenses$ | async; as licenses) {
        <div class="order-container">
          @for (license of licenses; track license) {
            @if (license.type === 'microphonekit') {
              <div
                matRipple
                class="order-container__item"
                (click)="goToTranscription(license)">
                <img src="assets/svg/kit.svg" />
                <div>{{ 'hub.microphone_kit' | transloco }} {{ $index + 1 }}</div>
                <button
                  mat-icon-button
                  aria-label="Example icon button with a open in new tab icon">
                  <mat-icon>double_arrow</mat-icon>
                </button>
              </div>
            }
          }
        </div>
      } @else {
        <div class="loading">
          <img src="/assets/animations/loading.gif" alt="" />
        </div>
      }
    </mat-card-content>
  </mat-card>

  <ng-template #loading>
    <div class="loading">
      <img src="/assets/animations/loading.gif" alt="" />
    </div>
  </ng-template>
</div>
